import styled from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';

export const CloseIcon = styled(IconButton)`
  position: absolute;
  top: 10px;
  right: 10px;

  font-size: 1.5rem;
`;

export const DialogStyled = styled(Dialog)`
  .MuiDialog-paperFullWidth {
    max-width: 480px;
  }

  .dialog-content {
    padding: 44px 20px 15px;
  }
`;

export default DialogStyled;
